window.theme = window.theme || {};
var afterResize = (function () {
    var t = {};
    return function (callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
        }
        if (t[uniqueId]) {
            clearTimeout(t[uniqueId]);
        }
        t[uniqueId] = setTimeout(callback, ms);
    };
})();
window.timber = window.timber || {};
!(function (a, b, c) {
    var d = window.matchMedia;
    "undefined" != typeof module && module.exports
        ? (module.exports = c(d))
        : "function" == typeof define && define.amd
        ? define(function () {
              return (b[a] = c(d));
          })
        : (b[a] = c(d));
})("enquire", this, function (a) {
    "use strict";
    function b(a, b) {
        var c,
            d = 0,
            e = a.length;
        for (d; e > d && ((c = b(a[d], d)), c !== !1); d++);
    }
    function c(a) {
        return "[object Array]" === Object.prototype.toString.apply(a);
    }
    function d(a) {
        return "function" == typeof a;
    }
    function e(a) {
        (this.options = a), !a.deferSetup && this.setup();
    }
    function f(b, c) {
        (this.query = b), (this.isUnconditional = c), (this.handlers = []), (this.mql = a(b));
        var d = this;
        (this.listener = function (a) {
            (d.mql = a), d.assess();
        }),
            this.mql.addListener(this.listener);
    }
    function g() {
        if (!a) throw new Error("matchMedia not present, legacy browsers require a polyfill");
        (this.queries = {}), (this.browserIsIncapable = !a("only all").matches);
    }
    return (
        (e.prototype = {
            setup: function () {
                this.options.setup && this.options.setup(), (this.initialised = !0);
            },
            on: function () {
                !this.initialised && this.setup(), this.options.match && this.options.match();
            },
            off: function () {
                this.options.unmatch && this.options.unmatch();
            },
            destroy: function () {
                this.options.destroy ? this.options.destroy() : this.off();
            },
            equals: function (a) {
                return this.options === a || this.options.match === a;
            },
        }),
        (f.prototype = {
            addHandler: function (a) {
                var b = new e(a);
                this.handlers.push(b), this.matches() && b.on();
            },
            removeHandler: function (a) {
                var c = this.handlers;
                b(c, function (b, d) {
                    return b.equals(a) ? (b.destroy(), !c.splice(d, 1)) : void 0;
                });
            },
            matches: function () {
                return this.mql.matches || this.isUnconditional;
            },
            clear: function () {
                b(this.handlers, function (a) {
                    a.destroy();
                }),
                    this.mql.removeListener(this.listener),
                    (this.handlers.length = 0);
            },
            assess: function () {
                var a = this.matches() ? "on" : "off";
                b(this.handlers, function (b) {
                    b[a]();
                });
            },
        }),
        (g.prototype = {
            register: function (a, e, g) {
                var h = this.queries,
                    i = g && this.browserIsIncapable;
                return (
                    h[a] || (h[a] = new f(a, i)),
                    d(e) && (e = { match: e }),
                    c(e) || (e = [e]),
                    b(e, function (b) {
                        d(b) && (b = { match: b }), h[a].addHandler(b);
                    }),
                    this
                );
            },
            unregister: function (a, b) {
                var c = this.queries[a];
                return c && (b ? c.removeHandler(b) : (c.clear(), delete this.queries[a])), this;
            },
        }),
        new g()
    );
});
!(function (a) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], a) : a(jQuery);
})(function (a) {
    "use strict";
    function b(a) {
        if (a instanceof Date) return a;
        if (String(a).match(g)) return String(a).match(/^[0-9]*$/) && (a = Number(a)), String(a).match(/\-/) && (a = String(a).replace(/\-/g, "/")), new Date(a);
        throw new Error("Couldn't cast `" + a + "` to a date object.");
    }
    function c(a) {
        var b = a.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
        return new RegExp(b);
    }
    function d(a) {
        return function (b) {
            var d = b.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
            if (d)
                for (var f = 0, g = d.length; g > f; ++f) {
                    var h = d[f].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),
                        j = c(h[0]),
                        k = h[1] || "",
                        l = h[3] || "",
                        m = null;
                    (h = h[2]), i.hasOwnProperty(h) && ((m = i[h]), (m = Number(a[m]))), null !== m && ("!" === k && (m = e(l, m)), "" === k && 10 > m && (m = "0" + m.toString()), (b = b.replace(j, m.toString())));
                }
            return (b = b.replace(/%%/, "%"));
        };
    }
    function e(a, b) {
        var c = "s",
            d = "";
        return a && ((a = a.replace(/(:|;|\s)/gi, "").split(/\,/)), 1 === a.length ? (c = a[0]) : ((d = a[0]), (c = a[1]))), 1 === Math.abs(b) ? d : c;
    }
    var f = [],
        g = [],
        h = { precision: 100, elapse: !1 };
    g.push(/^[0-9]*$/.source), g.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source), g.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source), (g = new RegExp(g.join("|")));
    var i = { Y: "years", m: "months", n: "daysToMonth", w: "weeks", d: "daysToWeek", D: "totalDays", H: "hours", M: "minutes", S: "seconds" },
        j = function (b, c, d) {
            (this.el = b),
                (this.$el = a(b)),
                (this.interval = null),
                (this.offset = {}),
                (this.options = a.extend({}, h)),
                (this.instanceNumber = f.length),
                f.push(this),
                this.$el.data("countdown-instance", this.instanceNumber),
                d && ("function" == typeof d ? (this.$el.on("update.countdown", d), this.$el.on("stoped.countdown", d), this.$el.on("finish.countdown", d)) : (this.options = a.extend({}, h, d))),
                this.setFinalDate(c),
                this.start();
        };
    a.extend(j.prototype, {
        start: function () {
            null !== this.interval && clearInterval(this.interval);
            var a = this;
            this.update(),
                (this.interval = setInterval(function () {
                    a.update.call(a);
                }, this.options.precision));
        },
        stop: function () {
            clearInterval(this.interval), (this.interval = null), this.dispatchEvent("stoped");
        },
        toggle: function () {
            this.interval ? this.stop() : this.start();
        },
        pause: function () {
            this.stop();
        },
        resume: function () {
            this.start();
        },
        remove: function () {
            this.stop.call(this), (f[this.instanceNumber] = null), delete this.$el.data().countdownInstance;
        },
        setFinalDate: function (a) {
            this.finalDate = b(a);
        },
        update: function () {
            if (0 === this.$el.closest("html").length) return void this.remove();
            var b,
                c = void 0 !== a._data(this.el, "events"),
                d = new Date();
            (b = this.finalDate.getTime() - d.getTime()),
                (b = Math.ceil(b / 1e3)),
                (b = !this.options.elapse && 0 > b ? 0 : Math.abs(b)),
                this.totalSecsLeft !== b &&
                    c &&
                    ((this.totalSecsLeft = b),
                    (this.elapsed = d >= this.finalDate),
                    (this.offset = {
                        seconds: this.totalSecsLeft % 60,
                        minutes: Math.floor(this.totalSecsLeft / 60) % 60,
                        hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
                        days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                        daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                        daysToMonth: Math.floor((this.totalSecsLeft / 60 / 60 / 24) % 30.4368),
                        totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
                        weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
                        months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
                        years: Math.abs(this.finalDate.getFullYear() - d.getFullYear()),
                    }),
                    this.options.elapse || 0 !== this.totalSecsLeft ? this.dispatchEvent("update") : (this.stop(), this.dispatchEvent("finish")));
        },
        dispatchEvent: function (b) {
            var c = a.Event(b + ".countdown");
            (c.finalDate = this.finalDate), (c.elapsed = this.elapsed), (c.offset = a.extend({}, this.offset)), (c.strftime = d(this.offset)), this.$el.trigger(c);
        },
    }),
        (a.fn.countdown = function () {
            var b = Array.prototype.slice.call(arguments, 0);
            return this.each(function () {
                var c = a(this).data("countdown-instance");
                if (void 0 !== c) {
                    var d = f[c],
                        e = b[0];
                    j.prototype.hasOwnProperty(e)
                        ? d[e].apply(d, b.slice(1))
                        : null === String(e).match(/^[$A-Z_][0-9A-Z_$]*$/i)
                        ? (d.setFinalDate.call(d, e), d.start())
                        : a.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi, e));
                } else new j(this, b[0], b[1]);
            });
        });
});
!(function (t) {
    function i(t, i) {
        (this.bearer = t), (this.options = i), this.hideEvent, (this.mouseOverMode = "hover" == this.options.trigger || "mouseover" == this.options.trigger || "onmouseover" == this.options.trigger);
    }
    (i.prototype = {
        show: function () {
            var t = this;
            this.options.modal && this.modalLayer.css("display", "block"),
                this.tooltip.css("display", "block"),
                t.mouseOverMode &&
                    (this.tooltip.mouseover(function () {
                        clearTimeout(t.hideEvent);
                    }),
                    this.tooltip.mouseout(function () {
                        clearTimeout(t.hideEvent), t.hide();
                    }));
        },
        hide: function () {
            var t = this;
            (this.hideEvent = setTimeout(function () {
                t.tooltip.hide();
            }, 100)),
                t.options.modal && t.modalLayer.hide(),
                this.options.onClose();
        },
        toggle: function () {
            this.tooltip.is(":visible") ? this.hide() : this.show();
        },
        addAnimation: function () {
            switch (this.options.animation) {
                case "none":
                    break;
                case "fadeIn":
                    this.tooltip.addClass("animated"), this.tooltip.addClass("fadeIn");
                    break;
                case "flipIn":
                    this.tooltip.addClass("animated"), this.tooltip.addClass("flipIn");
            }
        },
        setContent: function () {
            if ((t(this.bearer).css("cursor", "pointer"), this.options.content)) this.content = this.options.content;
            else {
                if (!this.bearer.attr("data-tooltip")) return;
                this.content = this.bearer.attr("data-tooltip");
            }
            if ("#" == this.content.charAt(0)) {
                if (this.options.delete_content) {
                    var i = t(this.content).html();
                    t(this.content).html(""), (this.content = i), delete i;
                } else t(this.content).hide(), (this.content = t(this.content).html());
                this.contentType = "html";
            } else this.contentType = "text";
            (tooltipId = ""),
                "" != this.bearer.attr("id") && (tooltipId = "id='darktooltip-" + this.bearer.attr("id") + "'"),
                (this.modalLayer = t("<ins class='darktooltip-modal-layer'></ins>")),
                (this.tooltip = t("<ins " + tooltipId + " class = 'dark-tooltip " + this.options.theme + " " + this.options.size + " " + this.options.gravity + "'><div>" + this.content + "</div><div class = 'tip'></div></ins>")),
                (this.tip = this.tooltip.find(".tip")),
                t("body").append(this.modalLayer),
                t("body").append(this.tooltip),
                "html" == this.contentType && this.tooltip.css("max-width", "none"),
                this.tooltip.css("opacity", this.options.opacity),
                this.addAnimation(),
                this.options.confirm && this.addConfirm();
        },
        setPositions: function () {
            var t = this.bearer.offset().left,
                i = this.bearer.offset().top;
            switch (this.options.gravity) {
                case "south":
                    (t += this.bearer.outerWidth() / 2 - this.tooltip.outerWidth() / 2), (i += -this.tooltip.outerHeight() - this.tip.outerHeight() / 2);
                    break;
                case "west":
                    (t += this.bearer.outerWidth() + this.tip.outerWidth() / 2), (i += this.bearer.outerHeight() / 2 - this.tooltip.outerHeight() / 2);
                    break;
                case "north":
                    (t += this.bearer.outerWidth() / 2 - this.tooltip.outerWidth() / 2), (i += this.bearer.outerHeight() + this.tip.outerHeight() / 2);
                    break;
                case "east":
                    (t += -this.tooltip.outerWidth() - this.tip.outerWidth() / 2), (i += this.bearer.outerHeight() / 2 - this.tooltip.outerHeight() / 2);
            }
            this.options.autoLeft && this.tooltip.css("left", t), this.options.autoTop && this.tooltip.css("top", i);
        },
        setEvents: function () {
            var i,
                o = this,
                s = o.options.hoverDelay;
            o.mouseOverMode
                ? this.bearer
                      .mouseenter(function () {
                          i = setTimeout(function () {
                              o.setPositions(), o.show();
                          }, s);
                      })
                      .mouseleave(function () {
                          clearTimeout(i), o.hide();
                      })
                : ("click" == this.options.trigger || "onclik" == this.options.trigger) &&
                  (this.tooltip.click(function (t) {
                      t.stopPropagation();
                  }),
                  this.bearer.click(function (t) {
                      t.preventDefault(), o.setPositions(), o.toggle(), t.stopPropagation();
                  }),
                  t("html").click(function () {
                      o.hide();
                  }));
        },
        activate: function () {
            this.setContent(), this.content && this.setEvents();
        },
        addConfirm: function () {
            this.tooltip.append("<ul class = 'confirm'><li class = 'darktooltip-yes'>" + this.options.yes + "</li><li class = 'darktooltip-no'>" + this.options.no + "</li></ul>"), this.setConfirmEvents();
        },
        setConfirmEvents: function () {
            var t = this;
            this.tooltip.find("li.darktooltip-yes").click(function (i) {
                t.onYes(), i.stopPropagation();
            }),
                this.tooltip.find("li.darktooltip-no").click(function (i) {
                    t.onNo(), i.stopPropagation();
                });
        },
        finalMessage: function () {
            if (this.options.finalMessage) {
                var t = this;
                t.tooltip.find("div:first").html(this.options.finalMessage),
                    t.tooltip.find("ul").remove(),
                    t.setPositions(),
                    setTimeout(function () {
                        t.hide(), t.setContent();
                    }, t.options.finalMessageDuration);
            } else this.hide();
        },
        onYes: function () {
            this.options.onYes(this.bearer), this.finalMessage();
        },
        onNo: function () {
            this.options.onNo(this.bearer), this.hide();
        },
    }),
        (t.fn.darkTooltip = function (o) {
            return this.each(function () {
                o = t.extend({}, t.fn.darkTooltip.defaults, o);
                var s = new i(t(this), o);
                s.activate();
            });
        }),
        (t.fn.darkTooltip.defaults = {
            animation: "none",
            confirm: !1,
            content: "",
            finalMessage: "",
            finalMessageDuration: 1e3,
            gravity: "south",
            hoverDelay: 0,
            modal: !1,
            no: "No",
            onNo: function () {},
            onYes: function () {},
            opacity: 0.9,
            size: "medium",
            theme: "dark",
            trigger: "hover",
            yes: "Yes",
            autoTop: !0,
            autoLeft: !0,
            onClose: function () {},
        });
})(jQuery);
